import { render } from "./StatusByPassing.vue?vue&type=template&id=f5f01018&scoped=true"
import script from "./StatusByPassing.vue?vue&type=script&lang=js"
export * from "./StatusByPassing.vue?vue&type=script&lang=js"

import "./StatusByPassing.vue?vue&type=style&index=0&id=f5f01018&scoped=true&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f01018"]])

export default __exports__